<template>
  <b-modal
    size="lg"
    centered
    no-close-on-backdrop
    ok-title="Enviar"
    id="modal-create-credential"
    modal
    :title="
      type === 'general'
        ? $ml.get('credentialPublica')
        : $ml.get('credentialPrivate')
    "
  >
    <div>
      <div @click="closeModal" class="btn-close">×</div>
      <div class="area-credential row">
        <p class="col" v-if="type === 'general'" style="line-height: 1.3">
          {{ $ml.get("credentialPublicaDescription") }}<br />
        </p>
        <p class="col" v-else style="line-height: 1.3">
          {{ $ml.get("credentialSentToSpecialist") }}
          <strong>{{ hackerName }}</strong>
          {{ $ml.get("credentialSentToSpecialistContinued") }}<br />
        </p>
      </div>

      <div class="form-group" style="position: relative">
        <svg
          v-show="!htmlText"
          @click="viewHtml()"
          width="24"
          height="24"
          class="ico-view-report"
        >
          <image
            xlink:href="../../assets/icons/eye.svg"
            width="24"
            height="24"
          />
        </svg>
        <svg
          v-show="htmlText"
          @click="htmlText = ''"
          width="24"
          height="24"
          class="ico-view-report"
        >
          <image
            xlink:href="../../assets/icons/eye-slash.svg"
            width="24"
            height="24"
          />
        </svg>
        <textarea
          v-show="!htmlText"
          class="form-control text-are-mark"
          rows="4"
          maxlength="30000"
          v-model="description"
          @keyup="controlTextArea()"
        >
        </textarea>

        <div
          v-show="htmlText"
          class="form-control h-100"
          v-html="htmlText"
        ></div>

        <!-- <svg
          v-show="description"
          width="18"
          height="18"
          class="delete-fill"
          @click="
            type === 'individual'
              ? deleteCredentialHacker()
              : deleteCredential()
          "
        >
          <image
            xlink:href="../../assets/svg/delete-fill.svg"
            width="18"
            height="18"
          />
        </svg> -->
      </div>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <b-button
        style="background: #730ba9; min-width: 90px"
        :disabled="loadingBtn || !description"
        size="sm"
        @click="
          type === 'individual'
            ? createCredentialHacker(ok)
            : createCredentialGeneral(ok)
        "
      >
        <span v-if="!loadingBtn">{{ $ml.get("save") }}</span>
        <TheSpinner v-else />
      </b-button>
      <b-button
        v-show="hasCredential"
        style="min-width: 90px"
        class="float-right btn-outline-extra"
        size="sm"
        variant="primary"
        @click="
          type === 'individual'
            ? deleteCredentialHacker(cancel)
            : deleteCredential(cancel)
        "
      >
        {{ $ml.get("delete") }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import Swal from "sweetalert2";
import CredentialService from "../../services/credential.service.js";

export default {
  name: "CreateCredentialProgram",
  props: ["type", "idProgram", "idHacker", "hackerName"],
  data() {
    return {
      showText: false,
      htmlText: "",
      credential: "",
      description: "",
      hasCredential: false,
    };
  },

  methods: {
    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(
        this.description,
        this.listFiles,
      );
    },

    controlTextArea() {
      if (this.description.length > 29900) {
        this.description = this.description.substring(0, 29900);
        this.descriptionMaxLengt = true;
      } else {
        this.descriptionMaxLengt = false;
      }
    },
    async getCredential() {
      try {
        const { data } = await CredentialService.getCredential(this.idProgram);
        this.description = data.credentials;
        this.hasCredential = true;
      } catch (error) {
        console.log(error);
      }
    },
    async getCredentialHacker(idHacker) {
      try {
        const { data } = await CredentialService.getCredentialHacker(
          this.idProgram,
          idHacker,
        );
        this.description = data.credentials;
        this.hasCredential = true;
      } catch (error) {
        console.log(error);
      }
    },
    async createCredentialGeneral(ok) {
      try {
        const { status } = await CredentialService.postCredential(
          this.idProgram,
          {
            credentials: this.description,
          },
        );
        if (status === 201) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("swalCredential"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.getCredential();
          this.description = "";
          this.$emit("closeModal");
          ok();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async createCredentialHacker(ok) {
      try {
        const { status } = await CredentialService.postCredentialHacker(
          this.idProgram,
          this.idHacker,
          {
            credentials: this.description,
          },
        );
        if (status === 201) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("swalCredential"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.getCredentialHacker();
          this.description = "";
          this.$emit("updateWhiteList");
          this.$emit("closeModal");
          ok();
        }
      } catch (error) {
        console.log(error);
      }
    },
    deleteCredentialHacker(closeModal) {
      var self = this;

      Swal.fire({
        title: self.$ml.get("labelDeleteCredential"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#730ba9",
        customClass: {
          cancelButton: "btn-outline-extra",
        },
        confirmButtonText: self.$ml.get("remove"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          CredentialService.deleteCredentialHacker(
            this.idProgram,
            this.idHacker,
          ).then(
            () => {
              Swal.fire({
                icon: "success",
                title: self.$ml.get("credentialDeleted"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              this.getCredentialHacker();
              this.$emit("updateWhiteList");
              this.$bvModal.hide("modal-create-credential");
              this.$emit("closeModal");
              closeModal();
            },
            (error) => {
              if (error.response.status == 403) {
                Swal.fire({
                  icon: "info",
                  title: self.$ml.get("unableToCompleteThisRequest"),
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
              if (error.response.status == 500) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: this.$ml.get("genericError"),
                });
              }
            },
          );
        }
      });
    },

    deleteCredential(closeModal) {
      var self = this;

      Swal.fire({
        title: self.$ml.get("labelDeleteCredential"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#730ba9",
        customClass: {
          cancelButton: "btn-outline-extra",
        },
        confirmButtonText: self.$ml.get("remove"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          CredentialService.deleteCredential(
            this.idProgram,
            this.idHacker,
          ).then(
            () => {
              Swal.fire({
                icon: "success",
                title: self.$ml.get("credentialDeleted"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              this.getCredential();
              this.$emit("closeModal");
              closeModal();
            },
            (error) => {
              if (error.response.status == 403) {
                Swal.fire({
                  icon: "info",
                  title: self.$ml.get("unableToCompleteThisRequest"),
                  showConfirmButton: false,
                  timer: 3000,
                });
              }

              if (error.response.status == 500) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: this.$ml.get("genericError"),
                });
              }
            },
          );
        }
      });
    },

    closeModal() {
      this.$bvModal.hide("modal-create-credential");
      this.description = "";
      this.$emit("closeModal");
    },
  },
  mounted() {
    if (this.type == "individual") {
      this.getCredentialHacker(this.idHacker);
      return;
    }
    this.getCredential();
  },
};
</script>
<style scoped>
.area-credential {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  font-size: 0.99rem;
}
.area-credential p {
  padding: 0px;
  margin: 0px;
}
.delete-fill {
  position: absolute;
  cursor: pointer;
  bottom: 5px;
  right: 13px;
}
.label-info-action {
  font-size: 0.8em;
  font-weight: 500;
}
.btn-close {
  font-size: 1.5rem;
  font-weight: 600;
  color: #8b8b8b;
  position: absolute;
  right: 15px;
  top: -47px;
  cursor: pointer;
}
</style>
